import { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { Logo } from "@/components/common/Logo";
import { GoldButton } from "@/components/common/Buttons";
import { NAV } from "@/lib/content";

export function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [pathname]);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled ? "backdrop-blur-xl bg-[#07080B]/85 border-b border-white/10" : "bg-transparent"
      }`}
      data-testid="site-header"
    >
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8 flex items-center justify-between h-20">
        <Logo size="h-16" />

        <nav className="hidden xl:flex items-center gap-1" data-testid="desktop-nav">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={`nav-${item.to.replace(/\//g, "") || "home"}`}
              className={({ isActive }) =>
                `relative px-3.5 py-2 text-[12.5px] tracking-wide transition-colors duration-300 ${
                  isActive ? "text-gold" : "text-slate-300 hover:text-white"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <GoldButton to="/ceder-votre-entreprise" testid="nav-cta-ceder" className="hidden sm:inline-flex !px-5 !py-3">
            Céder mon entreprise <ArrowUpRight className="h-4 w-4" />
          </GoldButton>
          <button
            className="xl:hidden text-white p-2"
            onClick={() => setOpen((o) => !o)}
            data-testid="mobile-menu-toggle"
            aria-label="Menu"
          >
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {/* Mobile drawer */}
      <div
        className={`xl:hidden overflow-hidden transition-[max-height] duration-500 bg-[#07080B]/98 backdrop-blur-xl border-b border-white/10 ${
          open ? "max-h-[640px]" : "max-h-0"
        }`}
        data-testid="mobile-nav"
      >
        <div className="px-6 py-6 flex flex-col gap-1">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `py-3 border-b border-white/5 text-sm tracking-wide ${isActive ? "text-gold" : "text-slate-200"}`
              }
            >
              {item.label}
            </NavLink>
          ))}
          <GoldButton to="/ceder-votre-entreprise" testid="mobile-cta-ceder" className="mt-5 w-full">
            Céder mon entreprise
          </GoldButton>
        </div>
      </div>
    </header>
  );
}
